import React from 'react';
import { TCS_PDF_PRIVACY, TCS_EMAIL } from '../../../helpers/messageText';

class TsAndCs extends React.Component {
	render() {
		return (
			<div className="termsModal" id="termsModal">
				<p>
					By registering a user account, you are entering into a legally binding agreement with Boardtrac Pty Ltd ABN 79 158 153 425 (<strong>we, us </strong>and <strong>our</strong>). In consideration of your access to and/or use of our hosted software application, end user applications (including the Boardtrac iPad application and any other application we may release from time to time) and content made available to you through the 'Info Hub' facility (the <strong>Product</strong>), you agree to be bound by and abide by the terms and conditions set out in these Terms of Use (<strong>Terms</strong>). <br />
				</p>
				<ol>
					<li className=" termsModalItem">
						<strong>Overview of Boardtrac</strong>
						<ol type="a">
							<li>
								Boardtrac comprises our hosted software application and end user applications, providing users with the ability to upload, manage, administer and download data, information and other materials (<strong>Data</strong>).
							</li>
							<li>
								Boardtrac includes access to content made available to you through the 'Infor Hub' facility (<strong>Info Hub Content</strong>), providing advisory guides and articles on business and corporate governance issues.
							</li>
						</ol>
					</li>
					<li className=" termsModalItem">
						<strong>Registration of user accounts</strong>
						<ol type="a">
							<li>
								You will need to register a user account in order to access the Product.
							</li>
							<li>
								You must first register as a user of the Product and then register as a member of your organisation.
							</li>
							<li>
								When registering a user account, you must provide accurate, complete and up-to-date information as requested on the registration page. It is your responsibility to inform us of any changes to that information. You may do this at any time by accessing your user account.
							</li>
							<li>
								By registering a user account, you consent to us sending you emails regarding your use of the Product.
							</li>
						</ol>
					</li>
					<li className=" termsModalItem sub-num">
						<strong>Conditions of use and restrictions</strong>
						<ol>
							<li className=" termsModalItem">
								<strong>Conditions</strong>
								<br />You must:
								<ol type="a">
									<li>
										comply with all reasonable directions issued by us regarding access to and use of the Product:
										<ol type="i">
											<li>
												specified in any documentation relating to the platform that is provided or made available by us from time to time (<strong>Documentation</strong>); or
											</li>
											<li>otherwise issued by us from time to time; and</li>
										</ol>
									</li>
									<li>
										keep your password for access to the platform confidential and secure.
									</li>
								</ol>
							</li>
							<li className=" termsModalItem">
								<strong>Access and usage restrictions</strong>
								<br />You must not:
								<ol type="a">
									<li>
										modify, add to, adapt, delete or amend any part of the Product without our prior written consent;
									</li>
									<li>
										sell, translate, network, publish, commercialise, rent, lease, assign, transfer, loan, or otherwise distribute all or part of the Product, or any adaptation, modification or derivative of all or part of the Product;
									</li>
									<li>
										reverse engineer, disassemble, or decompile any software forming part of the Product, unless permitted to do so by law, and then only strictly in accordance with the provisions or terms under which that right is given by such law;
									</li>
									<li>
										use the Product:
										<ol type="i">
											<li>for any unlawful purpose; or</li>
											<li>
												in a manner than contravenes any applicable laws;
											</li>
										</ol>
									</li>
									<li>
										remove, obscure or interfere with any copyright, acknowledgment, attribution, trade mark, warning, disclaimer statement, rights management information or serial numbers affixed to, incorporated in or otherwise applied in connection with the Product;
									</li>
									<li>
										(except in respect of Data) copy or download, in a systematic manner, any content, graphics, video, text or animation from the Product, or communicate or otherwise distribute such systematically-obtained content, graphics, video, text or animation;
									</li>
									<li>
										directly or indirectly, introduce or permit the introduction into the Product of any virus, worm, trojan or other malicious code into the Product, or in any other manner whatsoever, corrupt, degrade or disrupt the operation of the Product; or
									</li>
									<li>
										enter or upload any data, information or other materials into the Product, or otherwise use the Product:
										<ol type="i">
											<li>
												to engage in any activity which infringes a third party's rights, or in a manner which interferes with the rights of any other person;
											</li>
											<li>
												to infringe our intellectual property rights (including trade marks and copyright) or the intellectual property rights of any third party;
											</li>
											<li>
												in any way that is threatening, abusive, harassing, defamatory, obscene, fraudulent, misleading or deceptive or otherwise illegal; or
											</li>
											<li>
												in any way that constitutes misuse or resale of the Product or any associated materials.
											</li>
										</ol>
									</li>
								</ol>
							</li>
						</ol>
					</li>
					<li className=" termsModalItem">
						<strong>Intellectual Property Rights</strong>
						<strong> </strong>
						<ol>
							<li>
								<strong>Data</strong>
								<br />We agree that you (and/or your third party licensors) own (and will retain) all rights, title and interest (including all intellectual property rights) in the Data.&nbsp; You grant to us a non-exclusive licence to store and use Data in the Product (including in encrypted form) and to enable us to perform our obligations under these Terms.&nbsp;
								<br />
							</li>
							<li>
								<strong>Product and Documentation</strong>
								<br />You agree that we (and/or our third party licensors) own (and will retain) all rights, title and interest (including all intellectual property rights) in the Product (including WAR Content), and the Documentation.
							</li>
						</ol>
					</li>
					<li className=" termsModalItem">
						<strong>Exclusion, limitation of liability and indemnity</strong>
						<ol>
							<li className=" termsModalItem">
								<strong>No exclusion or limitation</strong>
								<ol type="a">
									<li>
										To the extent that you acquire goods or services from us as a consumer within the meaning of the Australian Consumer Law set out in Schedule 2 to the <em>Competition and Consumer Act 2010 </em>(Cth) (<strong>Australian Consumer Law</strong>), you may have certain rights and remedies (including, without limitation, consumer guarantee rights) that cannot be excluded, restricted or modified by agreement.
									</li>
									<li>
										Nothing in this section 5 operates to exclude, restrict or modify the application of any condition, warranty or provision implied by law, the exercise of any right or remedy, or the imposition of any liability under the Australian Consumer Law or any other statute where to do so would:
										<ol type="i">
											<li>
												contravene that statute; or
												<br />
											</li>
											<li>
												cause any term of these Terms to be void,
												<br />
											</li>
										</ol>
										(<strong>Non-excludable Obligation</strong>).
									</li>
									<li>
										To the extent permitted by law, our liability in respect of Non-excludable Obligations is limited to:
										<ol type="i">
											<li>
												the repair or, if necessary, the replacement of the Product; and
											</li>
											<li>
												the supply again of any services supplied under these Terms.
												<br />
											</li>
										</ol>
									</li>
								</ol>
							</li>
							<li className=" termsModalItem">
								<strong>
									Exclusion of implied obligations and limitation of liability
								</strong>
								<br />Except in relation to Non-excludable Obligations:
								<br />
								<ol type="a">
									<li>
										all conditions, warranties, guarantees, rights, remedies, liabilities or other terms that may be implied or imposed by custom, under the general law or by statute are expressly excluded under these Terms; and
										<br />
									</li>
									<li>
										to the extent permitted by law, we exclude liability for all direct, indirect or consequential liabilities, losses, damages, costs and expenses (including, without limitation, liability for loss of revenue, loss of goodwill, loss of customers, loss of capital, downtime costs, loss of profit, loss of or damage to reputation, loss under or in relation to any other contract, loss of data, loss of use of data, loss of anticipated savings or benefits) whether arising in contract, under any statute, in tort (for negligence or otherwise), or on any other basis in law or equity, suffered or incurred by any person:
										<ol type="i">
											<li>
												in connection with or in any way relating to the Product or its use;
											</li>
											<li>
												arising from any circumstance beyond our control; and
											</li>
											<li>
												otherwise under or in connection with these Terms.
												<br />
											</li>
										</ol>
									</li>
								</ol>
							</li>
							<li className=" termsModalItem">
								<strong>No guarantee of access</strong>
								<ol type="a">
									<li>
										Except in relation to Non-excludable Obligations, you acknowledge and agree that we make no representations, warranties or guarantees in relation to the availability, continuity, reliability or security of the Product (or any services provided in connection with the Product).
									</li>
									<li>
										We will not be liable if the Product (or any services provided in connection with the Product) are unavailable for any reason, including directly or indirectly as a result of:
										<ol type="i">
											<li>
												telecommunications unavailability, interruption, delay, bottleneck, failure or fault;
											</li>
											<li>
												negligent, malicious or wilful acts or omissions of third parties (including our third party service providers);
											</li>
											<li>
												maintenance or repairs carried out by us or any third party service provider in respect of any of the systems used in connection with the provision of the Product;
											</li>
											<li>
												services provided by third parties (including ISP Services) ceasing or becoming unavailable; or
											</li>
											<li>
												any circumstance or event beyond our reasonable control.
												<br />
											</li>
										</ol>
									</li>
								</ol>
							</li>
							<li className=" termsModalItem">
								<strong>Indemnity</strong>
								<br />You indemnify us &nbsp;against all expenses, losses, damages and costs (on a solicitor and own client basis and whether incurred by or awarded against us), that we may sustain or incur as a result, whether directly or indirectly, out of or in connection with:
								<ol type="a">
									<li>a breach by you of these Terms;</li>
									<li>
										any negligent or fraudulent act, error or omission by you;
									</li>
									<li>the use of your user account by you or any third party;</li>
									<li>
										the publication or transmission of any information that you enter or upload into the Product;
									</li>
									<li>
										loss of or damage to any property or injury to or death of any person caused by any act or omission by you; or
									</li>
									<li>
										any claim by a third party against us relating to:
										<ol type="i">
											<li>
												your use of the Product (or use by any person who accesses the Product using your user account); or
											</li>
											<li>
												any information that you enter or upload into the Product.
											</li>
										</ol>
									</li>
								</ol>
							</li>
							<li className=" termsModalItem">
								<strong>WAR Content</strong>
								<br />You acknowledge and agree that the WAR Content does not constitute, and should not be relied on as, legal advice.&nbsp; You must not make any claim or bring any action against us (or any third party directly or indirectly involved in the preparation or development of any WAR Content), in relation to the WAR Content.
								<br />
							</li>
							<li className=" termsModalItem">
								<strong>Data</strong>
								<br />You acknowledge and agree that:
								<br />
								<ol type="a">
									<li>
										you are solely responsible for the accuracy and completeness of the Data; and
										<br />
									</li>
									<li>
										the Product is not intended to be used as, and must not be relied upon by you as, a data backup or storage service.&nbsp; You must ensure that all Data is stored in other systems (not under our control) from where that Data can be accessed and retrieved by you.
									</li>
								</ol>
							</li>
						</ol>
					</li>
					<li className=" termsModalItem">
						<strong>Links to other Sites</strong>
						<br />We may, from time to time, publish links to other third party sites on the Product. These links are provided for your convenience only and by accessing these third party sites, you agree to any terms of access or use imposed by those sites. We do not endorse any material on third party sites and do not provide any warranty, or assume any responsibility regarding the quality, accuracy, source, merchantability, fitness for purpose or any other aspect of the material on those sites, nor do we warrant that material on other sites does not infringe the intellectual property rights of any other person.
					</li>
					<li className=" termsModalItem">
						<strong>Suspension and Termination</strong>
						<br />
						<ol>
							<li className=" termsModalItem">
								<ol type="a">
									<li>
										<strong /> We may:
										<br />
										<ol type="i">
											<li>
												suspend your access to the Product at any time for any reason, including but not limited to, a breach of clause 3.2 without having to give you notice;
											</li>
											<li>
												impose limits on certain features or restrict your access to all or part of the Product without having to give you notice; or
											</li>
											<li>
												terminate your access to and use of the Product (including your user account) without cause by giving you 14 days prior written notice.
											</li>
										</ol>
									</li>
									<li>
										Without prejudice to any other rights or remedies that we may have against you under these Terms or at law, if you breach any provision of these Terms, we may, by giving you written notice, terminate these Terms and disable your access to the Product, without any liability to you. This will include termination of your user account.
									</li>
									<li>
										You may close your user account at any time by sending an email to <a href={`mailto:${TCS_EMAIL}`}>{TCS_EMAIL}</a>
									</li>
								</ol>
							</li>
							<li className=" termsModalItem">
								<strong>Variation</strong>
								<br />We may vary these Terms from time to time by notice in writing to you. If the change is likely to:
								<ol type="a">
									<li>
										benefit you or have a neutral or minor detrimental impact on you – the change will be effective upon such notification; or
									</li>
									<li>
										have a significant detrimental impact on you – the change will be effective 10 days after we have notified you. <br />
										​​​​​​​If you do not accept a change made by us to these Terms, you may terminate these Terms by notice in writing to us to that effect (in which case you must immediately cease using the Product).
									</li>
								</ol>
							</li>
						</ol>
					</li>
					<li className=" termsModalItem">
						<strong>General</strong>
						<ol type="a">
							<li>
								If you are having difficulties accessing the Product or would like to lodge a query or complaint, please contact us at <a href={`mailto:${TCS_EMAIL}`}>{TCS_EMAIL}</a>. We take your feedback seriously and will promptly investigate and respond to all genuine complaints.
							</li>
							<li>
								We handle personal information we collect and hold about you in accordance with our Privacy Policy (located at: <a
									href={TCS_PDF_PRIVACY}
									target="_blank"
									rel="noopener noreferrer"
								>www.boardtrac.com.au/privacy-policy</a>). Our Privacy Policy forms part of these terms.
							</li>
							<li>
								You must not assign, sublicense or otherwise deal in any other way with any of your rights under these terms.
							</li>
							<li>
								If a provision of these Terms is invalid or unenforceable, it may be severed from these Terms and the remaining provisions of these Terms continue in force.
							</li>
							<li>
								These Terms are governed by the laws of Victoria, Australia and each party irrevocably and unconditionally submits to the non-exclusive jurisdiction of the courts of Victoria, Australia.
							</li>
							<li>
								These Terms constitute the entire agreement between the parties in connection with its subject matter and supersedes all previous agreements or understandings between the parties in connection with its subject matter.
							</li>
						</ol>
					</li>
				</ol>
				<iframe
					name="print_frame"
					width="0"
					height="0"
					frameBorder="0"
					src="about:blank"
					title="Boardtrac - Terms and Conditions"
				/>
			</div>
		);
	}
}

export default TsAndCs;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/TermsAndConditions.js